<template>
  <router-view v-slot="{ Component }">
    <template v-if="Component">
      <keep-alive>
        <component 
          :is="Component"
          v-if="$route.meta.keepAlive" 
        />
      </keep-alive>
      <component 
        :is="Component" 
        v-if="!$route.meta.keepAlive"
      />
    </template>
  </router-view>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

// 监听路由变化
watch(
  () => route.path,
  (newPath) => {
    console.log('路由变化:', newPath)
  }
)

onMounted(() => {
  console.log('App mounted')
})
</script>